<template>
  <div style="width: 100%">
    <table class="lyFormTable" :style="{ height: height + 'px' }">
      <thead ref="thead">
        <tr>
          <td v-for="(x, index) in forms" :key="index" :style="{ width: (x.width ? x.width : '') + 'px' }">
            <template v-if="x.type == 'selection'">
              <!-- <Checkbox v-model="single"></Checkbox> -->
              #
            </template>
            <template v-else>
              <span style="color: red; font-size: 18px" v-show="x.required">*</span>
              {{ x.title }}
            </template>
          </td>
          <td v-show="!hideBtn" class="fixed">增删</td>
          <td v-show="!hideBtn" class="fixed">排序</td>
        </tr>
      </thead>
      <tbody ref="tbody">
        <div :class="{ borderleft: showSon }" v-for="(item, index) in tableData" :key="index">
          <tr>
            <td v-for="(x, ind) in forms" :key="ind" :style="{ width: (x.width ? x.width : '') + 'px' }" :class="{
              red: x.required && utils.isEmpty(item[x.key]),
            }">
              <template v-if="x.type == 'selection'">
                <Checkbox v-model="item[x.check]"></Checkbox>
              </template>
              <Input v-if="x.type == 'Input'" v-model="item[x.key]" :type="x.type1" :rows="x.rows"
                :readonly="x.readonly" :disabled="x.disabled" :clearable="x.clearable" :maxlength="x.maxlength"
                :show-word-limit="x.showWordLimit"></Input>
              <InputNumber v-if="x.type == 'InputNumber'" v-model="item[x.key]" :min="x.min" :max="x.max"
                :readonly="x.readonly" :disabled="x.disabled" :clearable="x.clearable"
                @on-change="inputNumberChange($event, x.key, index)" style="width: 100%"></InputNumber>
              <Select v-model="item[x.key]" style="width: 100%" v-if="x.type == 'Select'" :multiple="x.multiple"
                :readonly="x.readonly" :disabled="x.disabled" :filterable="x.filterable" :allow-create="x.allowCreate"
                @on-create="handleCreate1($event, x)" @on-change="selectChange($event, x.key, index)" clearable>
                <Option :value="x.selectType == 'obj' ? y.id : y" v-for="(y, index1) in x.selectItems" :key="index1"
                  :label="x.selectType == 'obj' ? y.name : y">
                  <span>{{ x.selectType == "obj" ? y.name : y }}</span>
                </Option>
              </Select>
              <Select style="width: 100%" v-model="item[x.key]" v-if="x.type == 'Select1'">
                <Option v-for="(y, index1) in $t(x.st)" :value="index1" :key="index1">{{ x.selectType == "obj" ? y.name
                  : y }}
                </Option>
              </Select>
              <i-switch v-model="item[x.key]" v-if="x.type == 'bool'">
                <span slot="open">{{ $t("bool.true") }}</span>
                <span slot="close">{{ $t("bool.false") }}</span>
              </i-switch>
              <RadioGroup v-model="item[x.key]" v-if="x.type == 'abc'">
                <Radio :label="0">{{ $t("bool.false") }}</Radio>
                <Radio :label="1">{{ $t("bool.true") }}</Radio>
              </RadioGroup>
              <Select style="width: 100%" v-model="item[x.key]" v-if="x.type == 'bool2'">
                <Option :value="1">是</Option>
                <Option :value="0">否</Option>
              </Select>
              <toggle v-if="x.type == 'toggle'" v-model="item[x.key]" :selectItems="x.selectItems"></toggle>
              <selectCar v-if="x.type == 'selectCar'" :name="item[x.key1]" @update:name="item[x.key1] = $event"
                :id="item[x.key]" @update:id="item[x.key] = $event">
              </selectCar>
              <selectGroup v-if="x.type == 'selectGroup'" :name="item[x.key1]" @update:name="item[x.key1] = $event"
                :id="item[x.key]" @update:id="item[x.key] = $event">
              </selectGroup>
              <selectAddMap v-if="x.type == 'selectAddMap'" :address="item[x.key]"
                @update:address="item[x.key] = $event" :lng="item[x.keyX]" @update:lng="item[x.keyX] = $event"
                :lat="item[x.keyY]" @update:lat="item[x.keyY] = $event" :type="item[x.keyType]"
                @update:type="item[x.keyType] = $event" :disabled="x.disabled" :clearable="x.clearable" :list1="x.list1"
                :list2="x.list2">
              </selectAddMap>
              <AddressList :list="item[x.key]" :list1="x.list1" :list2="x.list2" v-if="x.type == 'AddressList'"
                @update:list="
                  item[x.key] = $event;
                $emit('AddressList', $event, x.key, index);
                " :noUpdate="x.noUpdate" :readonly="x.readonly"></AddressList>
              <selectPerson v-if="x.type == 'selectPerson'" :name="item[x.key1]" @update:name="item[x.key1] = $event"
                :id="item[x.key]" @update:id="item[x.key] = $event">
              </selectPerson>
              <selectDriver v-if="x.type == 'selectDriver'" :name="item[x.key1]" @update:name="item[x.key1] = $event"
                :id="item[x.key]" @update:id="item[x.key] = $event">
              </selectDriver>
              <lyyymmdd v-if="x.type == 'lyyymmdd'" :formate="x.formate" :clearable="x.clearable" v-model="item[x.key]">
              </lyyymmdd>
              <ly-photo v-if="x.type == 'lyPhoto'" ref="lyphoto" v-model="item[x.key]" :one="x.one"></ly-photo>
              <selectPerson v-if="x.type == 'selectPerson'" :name="item[x.key1]" @update:name="item[x.key1] = $event"
                :id="item[x.key]" @update:id="item[x.key] = $event">
              </selectPerson>
              <selectUser v-if="x.type == 'selectUser'" :name="item[x.key1]" @update:name="item[x.key1] = $event"
                :id="item[x.key]" @update:id="item[x.key] = $event">
              </selectUser>
            </td>
            <td class="fixed">
              <Button size="small" title="添加" icon="md-add" @click="add(index)"></Button>
              <Button size="small" title="删除" icon="md-close" @click="splice(index)"></Button>
            </td>
            <td v-show="!hideBtn" class="fixed">
              <Button size="small" title="上移" icon="md-arrow-round-up" @click="up(index)"></Button>
              <Button size="small" title="下移" icon="md-arrow-round-down" @click="down(index)"></Button>
            </td>
          </tr>
          <ul class="tableSon" v-if="showSon">
            <li v-for="(m, index) in tableSon" :key="index">
              <span>{{ m.title }}</span>
              <InputNumber v-model="item[m.keyp][m.keys]"></InputNumber>
            </li>
          </ul>
        </div>

        <div style="text-align: center; margin-top: 10px">
          <Button v-if="utils.isEmpty(tableData) && !hideBtn" :disabled="noFirst != undefined"
            @click="openAdd">添加条目</Button>
          <slot name="btns"></slot>
        </div>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  props: [
    "aaaaa",
    "forms",
    "item1",
    "hideBtn",
    "height",
    "noFirst",
    "showSon",
    "tableSon",
  ],
  data() {
    return {
      tableData: [],
      tableData2:[],
      single: false,
      itemds: {},
    };
  },
  methods: {
    openAdd() {
      
      let arr=[];
      this.tableData.unshift(JSON.parse(JSON.stringify(this.itemds)));
      console.log(this.tableData);
      this.$emit("addItem", 0);
    },
    tongbu() {
      const thead = this.$refs.thead;
      const tbody = this.$refs.tbody;
      tbody.addEventListener("scroll", function (e) {
        thead.scrollLeft = tbody.scrollLeft;
      });
    },
    splice(index) {
      this.tableData.splice(index, 1);
    },
    add(index) {
      var m = this.tableData[index];
      this.tableData.splice(index, 0, JSON.parse(JSON.stringify(m)));
      this.$emit("addItem", index);
    },
    allchange(v) {
      console.log(v);
      //求单价kgs/cbm/pl/的最大
      max(danjia(20, 'kgs'), danjia(10, 'cbm'), danjia(30, 'pl'));
    },
    yanzheng() {
      var forms = this.forms; //x
      var table = this.tableData; //item
      var result = true;
      atuu: for (let j = 0; j < table.length; j++) {
        for (let i = 0; i < forms.length; i++) {
          var item = table[j];
          var x = forms[i];
          if (x.required && this.utils.isEmpty(item[x.key])) {
            result =
              x.title +
              "必填（第" +
              (Number(j) + 1) +
              "行" +
              "第" +
              (i + 1) +
              "列）";
            break atuu;
          }
        }
      }
      return result;
    },
    inputNumberChange(v, x, index) {

      clearTimeout(this.time);
      this.time = setTimeout(() => {
        if (v == null) {
          v = 0;
        }
        this.$emit("fromInputNumber", v, x, index);
      }, 500);
    },
    selectChange(v, x, index) {
      clearTimeout(this.time);
      this.time = setTimeout(() => {
        this.$emit("fromSelect", v, x, index);
      }, 500);
    },
    up(index) {
      if (index == 0) {
        return;
      }
      var m = this.tableData[index];
      this.tableData.splice(index, 1);
      //setTimeout(() => {
      this.tableData.splice(index - 1, 0, m);
      //}, 5000);
    },
    down(index) {
      if (index == this.tableData.length) {
        return;
      }
      var m = this.tableData[index];
      this.tableData.splice(index, 1);
      //setTimeout(() => {
      this.tableData.splice(index + 1, 0, m);
    },
  },
  mounted() {
    this.tableData = this.aaaaa;
    this.itemds = this.item1;
    this.tongbu();
  },
  model: {
    prop: "aaaaa",
    event: "bbbbb",
  },
  watch: {
    aaaaa(v) {
      this.tableData = this.aaaaa;
      console.log(this.aaaaa,3333);
    },
  },
};
</script>
<style>
.lyFormTable {
  padding: 0px;
  height: calc(100% - 20px);
  margin-bottom: 20px;
  width: 100%;
  display: block;
  table-layout: fixed;
  /*auto（预设值）-表格的总宽度决定每一个储存格（cell）的最大值
fixed - 表格的总宽度决定于表格width的定义,以及各栏位（column）width的定义
为了让表格呈现滚动效果，必须设定table-layout:fixed 并且给与表格宽度。 */
}

.lyFormTable tr {
  width: 100%;
}

.lyFormTable .borderleft {
  border-left: 4px solid #89baff;
  margin-bottom: 10px;
}

.lyFormTable th {
  line-height: 3;
}

.lyFormTable td {
  padding: 2px 4px;
  text-align: left;
  width: 120px;
}

.lyFormTable td.red {
  border: solid 2px red;
}

.lyFormTable thead {
  background: #ececec;
  width: calc(100% - 1em);
}

.lyFormTable thead tr,
.lyFormTable tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}

.lyFormTable tbody {
  display: block;
  width: 100%;
  height: calc(100% - 32px);
  overflow-y: auto;
  overflow-x: auto;
  padding-top: 10px;
}

.lyFormTable thead {
  display: block;
  width: 100%;
  overflow-x: hidden;
}

.lyFormTable td.fixed,
.lyFormTable th.fixed {
  /* position: sticky; */
  right: 0;
  /* 首行永远固定在左侧 */
  z-index: 1;
  padding-left: 15px;
  width: 80px;
}

.lyFormTable thead td.fixed {
  background: #ececec;

}

.lyFormTable .tableSon {
  width: 100%;
  display: flex;
  height: 30px;
}

.lyFormTable .tableSon li {
  margin-left: 15px;
}
</style>


// WEBPACK FOOTER //
// ../common/src/components/tableForm.vue